import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, unref as _unref, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "dashboard-container"
};
const _hoisted_2 = {
  class: "dashboard-header"
};
const _hoisted_3 = {
  class: "time-section"
};
const _hoisted_4 = {
  class: "current-time"
};
const _hoisted_5 = {
  class: "current-date"
};
const _hoisted_6 = {
  class: "dashboard-content"
};
const _hoisted_7 = {
  class: "left-panel"
};
const _hoisted_8 = {
  class: "stats-grid"
};
const _hoisted_9 = {
  class: "stat-icon"
};
const _hoisted_10 = {
  class: "stat-content"
};
const _hoisted_11 = {
  class: "stat-value"
};
const _hoisted_12 = {
  class: "stat-label"
};
const _hoisted_13 = {
  class: "chart-section"
};
const _hoisted_14 = {
  class: "chart-card"
};
const _hoisted_15 = {
  class: "right-panel"
};
const _hoisted_16 = {
  class: "status-card"
};
const _hoisted_17 = {
  class: "status-list"
};
const _hoisted_18 = {
  class: "status-name"
};
const _hoisted_19 = {
  class: "status-value"
};
const _hoisted_20 = {
  class: "activity-card"
};
const _hoisted_21 = {
  class: "recent-card"
};
const _hoisted_22 = {
  class: "activity-list"
};
const _hoisted_23 = {
  class: "activity-time"
};
const _hoisted_24 = {
  class: "activity-desc"
};
import { ref, onMounted, onBeforeUnmount } from 'vue';
import * as echarts from 'echarts';
import { UserIcon, ServerIcon, ChartBarIcon, CpuChipIcon, ArrowUpIcon, ArrowDownIcon } from '@heroicons/vue/24/outline';
export default {
  __name: 'index',
  setup(__props) {
    const currentTime = ref('');
    const currentDate = ref('');
    const lineChartRef = ref(null);
    const pieChartRef = ref(null);
    let lineChart = null;
    let pieChart = null;
    let timeInterval = null;

    // 统计数据
    const statsData = ref([{
      icon: UserIcon,
      value: '1,234',
      label: '在线用户',
      trend: 'up',
      change: '+12%'
    }, {
      icon: ServerIcon,
      value: '98.5%',
      label: '系统可用性',
      trend: 'up',
      change: '+0.3%'
    }, {
      icon: ChartBarIcon,
      value: '45,678',
      label: '今日访问',
      trend: 'up',
      change: '+8.2%'
    }, {
      icon: CpuChipIcon,
      value: '23.4%',
      label: 'CPU使用率',
      trend: 'down',
      change: '-2.1%'
    }]);

    // 系统状态
    const systemStatus = ref([{
      name: '数据库',
      status: 'online',
      value: '正常'
    }, {
      name: '缓存服务',
      status: 'online',
      value: '正常'
    }, {
      name: '消息队列',
      status: 'warning',
      value: '警告'
    }, {
      name: '文件存储',
      status: 'online',
      value: '正常'
    }, {
      name: '监控服务',
      status: 'online',
      value: '正常'
    }]);

    // 最近活动
    const recentActivities = ref([{
      time: '10:30',
      description: '用户登录系统'
    }, {
      time: '10:25',
      description: '数据备份完成'
    }, {
      time: '10:20',
      description: '系统更新推送'
    }, {
      time: '10:15',
      description: '安全扫描完成'
    }, {
      time: '10:10',
      description: '性能监控报告'
    }]);

    // 更新时间
    const updateTime = () => {
      const now = new Date();
      currentTime.value = now.toLocaleTimeString('zh-CN', {
        hour12: false
      });
      currentDate.value = now.toLocaleDateString('zh-CN', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        weekday: 'long'
      });
    };

    // 初始化折线图
    const initLineChart = () => {
      if (!lineChartRef.value) return;
      lineChart = echarts.init(lineChartRef.value);
      const option = {
        backgroundColor: 'transparent',
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: ['00:00', '04:00', '08:00', '12:00', '16:00', '20:00', '24:00'],
          axisLine: {
            lineStyle: {
              color: '#1e40af'
            }
          },
          axisLabel: {
            color: '#60a5fa'
          }
        },
        yAxis: {
          type: 'value',
          axisLine: {
            lineStyle: {
              color: '#1e40af'
            }
          },
          axisLabel: {
            color: '#60a5fa'
          },
          splitLine: {
            lineStyle: {
              color: '#1e40af',
              opacity: 0.3
            }
          }
        },
        series: [{
          data: [120, 200, 150, 80, 70, 110, 130],
          type: 'line',
          smooth: true,
          lineStyle: {
            color: '#00d4ff',
            width: 3
          },
          itemStyle: {
            color: '#00d4ff'
          },
          areaStyle: {
            color: {
              type: 'linear',
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [{
                offset: 0,
                color: 'rgba(0, 212, 255, 0.3)'
              }, {
                offset: 1,
                color: 'rgba(0, 212, 255, 0.05)'
              }]
            }
          }
        }]
      };
      lineChart.setOption(option);
    };

    // 初始化饼图
    const initPieChart = () => {
      if (!pieChartRef.value) return;
      pieChart = echarts.init(pieChartRef.value);
      const option = {
        backgroundColor: 'transparent',
        series: [{
          type: 'pie',
          radius: ['40%', '70%'],
          center: ['50%', '50%'],
          data: [{
            value: 35,
            name: '系统管理',
            itemStyle: {
              color: '#00d4ff'
            }
          }, {
            value: 25,
            name: '用户操作',
            itemStyle: {
              color: '#1e40af'
            }
          }, {
            value: 20,
            name: '数据处理',
            itemStyle: {
              color: '#3b82f6'
            }
          }, {
            value: 20,
            name: '其他',
            itemStyle: {
              color: '#60a5fa'
            }
          }],
          label: {
            color: '#60a5fa',
            fontSize: 12
          },
          labelLine: {
            lineStyle: {
              color: '#60a5fa'
            }
          }
        }]
      };
      pieChart.setOption(option);
    };
    onMounted(() => {
      updateTime();
      timeInterval = setInterval(updateTime, 1000);
      setTimeout(() => {
        initLineChart();
        initPieChart();
      }, 100);

      // 响应式处理
      window.addEventListener('resize', () => {
        lineChart?.resize();
        pieChart?.resize();
      });
    });
    onBeforeUnmount(() => {
      if (timeInterval) {
        clearInterval(timeInterval);
      }
      lineChart?.dispose();
      pieChart?.dispose();
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[0] || (_cache[0] = _createElementVNode("div", {
        class: "welcome-section"
      }, [_createElementVNode("h1", {
        class: "welcome-title"
      }, "欢迎使用管理系统"), _createElementVNode("p", {
        class: "welcome-subtitle"
      }, "实时监控 · 数据分析 · 智能管理")], -1)), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, _toDisplayString(currentTime.value), 1), _createElementVNode("div", _hoisted_5, _toDisplayString(currentDate.value), 1)])]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(statsData.value, (stat, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: "stat-card",
          key: index
        }, [_createElementVNode("div", _hoisted_9, [(_openBlock(), _createBlock(_resolveDynamicComponent(stat.icon)))]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, _toDisplayString(stat.value), 1), _createElementVNode("div", _hoisted_12, _toDisplayString(stat.label), 1)]), _createElementVNode("div", {
          class: _normalizeClass(["stat-trend", stat.trend])
        }, [stat.trend === 'up' ? (_openBlock(), _createBlock(_unref(ArrowUpIcon), {
          key: 0
        })) : (_openBlock(), _createBlock(_unref(ArrowDownIcon), {
          key: 1
        })), _createTextVNode(" " + _toDisplayString(stat.change), 1)], 2)]);
      }), 128))]), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_cache[1] || (_cache[1] = _createElementVNode("h3", {
        class: "chart-title"
      }, "系统状态监控", -1)), _createElementVNode("div", {
        class: "chart-container",
        ref_key: "lineChartRef",
        ref: lineChartRef
      }, null, 512)])])]), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_cache[2] || (_cache[2] = _createElementVNode("h3", {
        class: "card-title"
      }, "系统状态", -1)), _createElementVNode("div", _hoisted_17, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(systemStatus.value, (status, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: "status-item",
          key: index
        }, [_createElementVNode("div", {
          class: _normalizeClass(["status-indicator", status.status])
        }, null, 2), _createElementVNode("span", _hoisted_18, _toDisplayString(status.name), 1), _createElementVNode("span", _hoisted_19, _toDisplayString(status.value), 1)]);
      }), 128))])]), _createElementVNode("div", _hoisted_20, [_cache[3] || (_cache[3] = _createElementVNode("h3", {
        class: "card-title"
      }, "活动统计", -1)), _createElementVNode("div", {
        class: "activity-chart",
        ref_key: "pieChartRef",
        ref: pieChartRef
      }, null, 512)]), _createElementVNode("div", _hoisted_21, [_cache[4] || (_cache[4] = _createElementVNode("h3", {
        class: "card-title"
      }, "最近活动", -1)), _createElementVNode("div", _hoisted_22, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(recentActivities.value, (activity, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: "activity-item",
          key: index
        }, [_createElementVNode("div", _hoisted_23, _toDisplayString(activity.time), 1), _createElementVNode("div", _hoisted_24, _toDisplayString(activity.description), 1)]);
      }), 128))])])])])]);
    };
  }
};